import { ConfirmModal } from '@festo-ui/react';
import * as React from 'react';

import './CalculationModal.scss';

import useTranslation from '../../features/translation/hooks/useTranslation';

enum TranslationKeys {
  APPLY = 'apply',
}

export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOk: () => void;
  onCancel: () => void;
  title: string;
  body: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onCancel, onClose, onOk, title, body }) => {
  const t = useTranslation();
  return (
    <ConfirmModal
      title={title}
      body={body}
      isOpen={isOpen}
      onCancel={onCancel}
      onClose={onClose}
      onOk={onOk}
      ok={t(TranslationKeys.APPLY)}
    />
  );
};

export default Modal;
